export const StatsIcon = () => {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 9L1 19M13 9L13 19M7 1L7 19M19 1V19" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}

export default StatsIcon;